import map from "lodash/map";
import { FIELD_SKILLS_FRAMEWORK_IDS_KEY } from "PFApp/constants/activity_form/activity_form_field_keys";
import { Stack } from "PFComponents/containers";
import { LoadingDots } from "PFComponents/loading_dots";
import { SkillsFramework } from "PFCore/types";
import { useFormContext } from "react-hook-form";

import { useFormSelectedSkillsFrameworks } from "../../../hooks/use_form_selected_skills_frameworks";
import { FormSection, SectionProps } from "../../form_section";
import { useSkillsFrameworksWarningAlert } from "./hooks/use_skills_frameworks_warning_alert";
import { SkillsFrameworksEmptyState } from "./parts/skills_frameworks_empty_state";
import { SkillsFrameworksList } from "./parts/skills_frameworks_list";
import { SkillsFrameworksSectionActions } from "./parts/skills_frameworks_section_actions";

export const SkillsFrameworksFormSection = ({ id, title }: SectionProps) => {
  const { selectedSkillsFrameworks, isSkillsFrameworksLoading } = useFormSelectedSkillsFrameworks();
  const { resetWarningEffect } = useSkillsFrameworksWarningAlert();
  const { setValue } = useFormContext();

  const hasSkillsFrameworks = selectedSkillsFrameworks.length > 0;

  const handleFrameworksChange = (selectedFrameworks: SkillsFramework[]) => {
    setValue(FIELD_SKILLS_FRAMEWORK_IDS_KEY, map(selectedFrameworks, "id"), { shouldDirty: true });
    resetWarningEffect();
  };

  return (
    <FormSection
      id={id}
      title={title}
      actions={<SkillsFrameworksSectionActions onFrameworksChange={handleFrameworksChange} />}
      qaId="ActivityForm.skillsFrameworks"
    >
      <Stack gap="spacingLg" center={!hasSkillsFrameworks}>
        {isSkillsFrameworksLoading && <LoadingDots circlesEnabled circleSize="xs" centered />}
        {!isSkillsFrameworksLoading &&
          (hasSkillsFrameworks ? <SkillsFrameworksList /> : <SkillsFrameworksEmptyState />)}
      </Stack>
    </FormSection>
  );
};
